"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
const DefaultStepper_1 = require("./DefaultStepper");
const CustomHorizontalConnector = (0, styles_1.styled)(DefaultStepper_1.StepConnector)(({ theme }) => ({
    [`& .${DefaultStepper_1.stepConnectorClasses.line}`]: {
        borderLeftWidth: 2,
        borderColor: theme.palette.grey[300],
        marginTop: 26,
        marginBottom: 12,
        height: 'calc(100% - 24px)',
        marginLeft: 26,
        marginRight: 26,
    },
}));
exports.default = CustomHorizontalConnector;
//# sourceMappingURL=CustomHorizontalConnector.js.map